// Deutsche Vorwahlen für das Frontend (gekürzte Version für bessere Performance)
// Die wichtigsten und häufigsten Vorwahlen aus der vollständigen Liste

export const GERMAN_AREA_CODES = [
  // 6-stellige Vorwahlen
  "033051", "033053", "033054", "033055", "033056", "033080", "033082", "033083", "033084", "033085",
  
  // 5-stellige Vorwahlen (Auswahl der häufigsten)
  "02151", "02152", "02153", "02154", "02156", "02157", "02158", "02159", "02161", "02162",
  "02163", "02164", "02165", "02166", "02171", "02173", "02174", "02175", "02181", "02182",
  "03301", "03302", "03303", "03304", "03305", "03306", "03307", "03308", "03309", "03320",
  "03321", "03322", "03323", "03324", "03325", "03326", "03327", "03328", "03329", "03330",
  "03331", "03332", "03334", "03335", "03336", "03337", "03338", "03339", "03341", "03342",
  "03343", "03344", "03345", "03346", "03347", "03348", "03349", "03351", "03352", "03353",
  "03354", "03355", "03356", "03357", "03358", "03361", "03362", "03363", "03364", "03365",
  "03366", "03367", "03368", "03369", "03371", "03372", "03373", "03374", "03375", "03376",
  "03377", "03378", "03379", "03381", "03382", "03383", "03384", "03385", "03386", "03387",
  "03388", "03389", "03391", "03392", "03393", "03394", "03395", "03396", "03397", "03398",
  "03901", "03902", "03903", "03904", "03905", "03906", "03907", "03909", "03920", "03921",
  "03922", "03923", "03924", "03925", "03926", "03927", "03928", "03929", "03930", "03931",
  "03932", "03933", "03934", "03935", "03936", "03937", "03938", "03939", "03940", "03941",
  "03943", "03944", "03945", "03946", "03947", "03948", "03949", "03950", "03951", "03952",
  "03953", "03954", "03955", "03956", "03957", "03958", "03959", "03960", "03961", "03962",
  "03963", "03964", "03965", "03966", "03967", "03969", "03971", "03972", "03973", "03974",
  "03975", "03976", "03977", "03979", "03981", "03982", "03983", "03984", "03985", "03986",
  "03987", "03988", "03991", "03992", "03994", "03995", "03996", "03997", "03998", "03999",
  
  // 4-stellige Vorwahlen (alle wichtigen Städte)
  "0201", "0202", "0203", "0208", "0209", "0211", "0212", "0214", "0221", "0228", "0231", "0234",
  "0235", "0236", "0237", "0238", "0251", "0252", "0254", "0255", "0256", "0257", "0258", "0259",
  "0261", "0262", "0263", "0264", "0265", "0266", "0267", "0268", "0269", "0271", "0272", "0273",
  "0274", "0275", "0276", "0277", "0278", "0279", "0281", "0282", "0283", "0284", "0285", "0286",
  "0287", "0291", "0292", "0293", "0294", "0295", "0296", "0297", "0298", "0361", "0362", "0363",
  "0364", "0365", "0366", "0367", "0368", "0369", "0371", "0372", "0373", "0374", "0375", "0376",
  "0377", "0381", "0382", "0383", "0384", "0385", "0386", "0387", "0388", "0389", "0391", "0392",
  "0393", "0394", "0395", "0396", "0397", "0398", "0399", "0411", "0412", "0413", "0414", "0415",
  "0416", "0417", "0418", "0419", "0421", "0422", "0423", "0424", "0425", "0426", "0427", "0428",
  "0429", "0431", "0432", "0433", "0434", "0435", "0436", "0438", "0439", "0441", "0442", "0443",
  "0444", "0445", "0446", "0447", "0448", "0449", "0451", "0452", "0453", "0454", "0455", "0456",
  "0457", "0458", "0459", "0461", "0462", "0463", "0464", "0465", "0466", "0467", "0468", "0469",
  "0471", "0472", "0473", "0474", "0475", "0476", "0477", "0478", "0479", "0481", "0482", "0483",
  "0484", "0485", "0486", "0487", "0488", "0489", "0491", "0492", "0493", "0494", "0495", "0496",
  "0497", "0498", "0499", "0511", "0512", "0513", "0514", "0515", "0516", "0517", "0518", "0519",
  "0521", "0522", "0523", "0524", "0525", "0526", "0527", "0528", "0529", "0531", "0532", "0533",
  "0534", "0535", "0536", "0537", "0538", "0539", "0541", "0542", "0543", "0544", "0545", "0546",
  "0547", "0548", "0549", "0551", "0552", "0553", "0554", "0555", "0556", "0557", "0558", "0559",
  "0561", "0562", "0563", "0564", "0565", "0566", "0567", "0568", "0569", "0571", "0572", "0573",
  "0574", "0575", "0576", "0577", "0578", "0579", "0581", "0582", "0583", "0584", "0585", "0586",
  "0587", "0591", "0592", "0593", "0594", "0595", "0596", "0597", "0598", "0599", "0621", "0622",
  "0623", "0624", "0625", "0626", "0627", "0628", "0629", "0631", "0632", "0633", "0634", "0635",
  "0636", "0637", "0638", "0639", "0641", "0642", "0643", "0644", "0645", "0646", "0647", "0648",
  "0649", "0651", "0652", "0653", "0654", "0655", "0656", "0657", "0658", "0659", "0661", "0662",
  "0663", "0664", "0665", "0666", "0667", "0668", "0669", "0671", "0672", "0673", "0674", "0675",
  "0676", "0677", "0678", "0679", "0681", "0682", "0683", "0684", "0685", "0686", "0687", "0688",
  "0689", "0691", "0692", "0693", "0694", "0695", "0696", "0697", "0698", "0699", "0711", "0712",
  "0713", "0714", "0715", "0716", "0717", "0718", "0719", "0721", "0722", "0723", "0724", "0725",
  "0726", "0727", "0728", "0729", "0731", "0732", "0733", "0734", "0735", "0736", "0737", "0738",
  "0739", "0741", "0742", "0743", "0744", "0745", "0746", "0747", "0748", "0749", "0751", "0752",
  "0753", "0754", "0755", "0756", "0757", "0758", "0759", "0761", "0762", "0763", "0764", "0765",
  "0766", "0767", "0768", "0769", "0771", "0772", "0773", "0774", "0775", "0776", "0777", "0778",
  "0779", "0781", "0782", "0783", "0784", "0785", "0791", "0792", "0793", "0794", "0795", "0796",
  "0797", "0798", "0799", "0821", "0822", "0823", "0824", "0825", "0826", "0827", "0828", "0829",
  "0831", "0832", "0833", "0834", "0835", "0836", "0837", "0838", "0841", "0842", "0843", "0844",
  "0845", "0846", "0847", "0848", "0851", "0852", "0853", "0854", "0855", "0856", "0857", "0858",
  "0859", "0861", "0862", "0863", "0864", "0865", "0866", "0867", "0868", "0869", "0871", "0872",
  "0873", "0874", "0875", "0876", "0877", "0878", "0881", "0882", "0883", "0884", "0885", "0886",
  "0887", "0888", "0891", "0892", "0893", "0894", "0895", "0896", "0897", "0898", "0899", "0911",
  "0912", "0913", "0914", "0915", "0916", "0917", "0918", "0919", "0921", "0922", "0923", "0924",
  "0925", "0926", "0927", "0928", "0929", "0931", "0932", "0933", "0934", "0935", "0941", "0942",
  "0943", "0944", "0945", "0946", "0947", "0948", "0949", "0951", "0952", "0953", "0954", "0955",
  "0956", "0957", "0958", "0959", "0961", "0962", "0963", "0964", "0965", "0966", "0967", "0971",
  "0972", "0973", "0974", "0975", "0976", "0977", "0981", "0982", "0983", "0984", "0985", "0991",
  "0992", "0993", "0994", "0995", "0996", "0997", "0998", "0999",
  
  // 3-stellige Vorwahlen (Großstädte)
  "030", "040", "069", "089"
].sort((a, b) => {
  // Sortiere nach Länge (längste zuerst) für korrekte Erkennung
  if (a.length !== b.length) {
    return b.length - a.length;
  }
  return a.localeCompare(b);
});

export default GERMAN_AREA_CODES;
